import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import arthereumProvider from "../../backend/ArthereumProvider";
import { PAGE_NAME } from "../../types";
import PageLoadingComponent from "../components/PageLoadingComponent";
import { actions } from "../redux";
import getUserSignInData from "../utils/getUserSignInData";
import {
  LOCAL_STORAGE_DATA,
  LocalStorageController,
} from "../utils/LocalStorageController";

import { isAllowedDomain, UnsupportedDomainCard } from "../components/DomainGuard";

function Entry() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [unKnowError, setUnKnowError] = useState(false);
  const [isWrongDomain, setIsWrongDomain] = useState(false);
  const dispatch = useDispatch();

  const init = async () => {
    try {
      if (isLoading) {
        return;
      }

      // Check domain first, before any async operations
      if (!isAllowedDomain()) {
        setIsWrongDomain(true);
        return;
      }

      setUnKnowError(false);
      setIsLoading(true);

      const SYSTEM_FULLY_INITIALIZED = LocalStorageController.connect().getData(
        LOCAL_STORAGE_DATA.SYSTEM_FULLY_INITIALIZED,
        "string"
      );

      if (SYSTEM_FULLY_INITIALIZED === "false" || !SYSTEM_FULLY_INITIALIZED) {
        navigate(PAGE_NAME.LOGIN, { replace: true });
        return;
      }
      const userCredentials = await getUserSignInData();
      console.log("User credentials", userCredentials);

      // sign in
      const user = await arthereumProvider.signIn(userCredentials);
      dispatch(actions.setActualUser(user));
      LocalStorageController.connect().storeData(
        LOCAL_STORAGE_DATA.SIGN_IN_PATH,
        user?.user?.signUpMethod
      );
      //save user in redux
      navigate(PAGE_NAME.HOME, { replace: true });
    } catch (error: any) {
      if (error?.message === "Invalid credentials") {
        navigate(PAGE_NAME.LOGIN, { replace: true });
      } else {
        setUnKnowError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  // Show domain redirect card if on wrong domain
  if (isWrongDomain) {
    return <UnsupportedDomainCard />;
  }

  return <PageLoadingComponent />;
}

export default Entry;
